// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@eisinc/Overrides/Components/ProductCarouselProduct";
import { customBadgesStyles, sharedProductDescriptionStyles } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductStyles.wrapper = {
    css: css`
        position: relative;
        height: 100%;
    `,
};

productCarouselProductStyles.actionsTemplateWrapper = {
    css: css`
        position: absolute;
        top: 4px;
        right: 4px;
        z-index: 1;
    `,
};
productCarouselProductStyles.productAddToListLinkStyles = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
};

productCarouselProductStyles.thumbnailProductDescriptionStyles = {
    ...sharedProductDescriptionStyles({ lines: 3, lineHeight: 14, fontSize: 12 }),
};

productCarouselProductStyles.miniCardProductDescriptionStyles = {
    ...sharedProductDescriptionStyles({ lines: 3 }),
};

productCarouselProductStyles.productDescriptionStyles = {
    ...sharedProductDescriptionStyles(),
};

productCarouselProductStyles.productActions = {
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            > div:last-child {
                flex: 1;
            }
        `,
    },
    productAddToCartButtonStyles: {
        css: css`
            padding: 0;
            width: 100%;
        `,
    },
    uomSelect: {
        cssOverrides: {
            inputSelect: css`
                width: 91px;
            `,
        },
    },
};

productCarouselProductStyles.partNumbersAndBrandNameWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 2px;
        &:empty {
            display: none;
        }
    `,
};

productCarouselProductStyles.badgesContainerStyle = {
    css: css`
        ${({ view }: any) =>
            view !== "miniCard"
                ? css`
                      position: absolute;
                      bottom: 4px;
                      left: 4px;
                  `
                : css`
                      margin-top: auto;
                  `}

        ${customBadgesStyles.container.css}
    `,
};

productCarouselProductStyles.badgeAreaWrapper = {
    css: css`
        ${({ showOverlayBadge }: any) =>
            showOverlayBadge
                ? css`
                      display: block;
                  `
                : css`
                      display: none;
                  `}
    `,
};
productCarouselProductStyles.triggererWrapper = {
    css: css`
        max-width: 20px;
        max-height: 20px;
    `,
};
